'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { useFormContext } from 'react-hook-form';
import LoadingIcon from 'src/libs/components/icons/loading';
import useSWR from 'swr';
import VideoStyleItem from './video-style-item';

interface VideoStyle {
    id: number;
    title: string;
    thumbnail: string;
    postType: {
        id: number;
        name: string;
        type: string;
        subject: string;
        full_name: string;
    };
    video: {
        url: string;
        hls: string;
    };
}

function AddPageFormStep5() {
    const form = useFormContext();
    const { formState } = form;
    const { category_id, field_id, store_type } = form.getValues();
    const hasError = formState.errors['video_style_id'];

    const { data, isLoading } = useSWR<{ data: VideoStyle[] }>(ApiKeys.GET_VIDEO_STYLES, (url: string) =>
        fetcher(url, 'dashboard', 'GET', {
            params: {
                category_id,
                field_id,
                store_type,
                page_id: false
            }
        })
    );

    if (isLoading) {
        return (
            <div className='flex h-14 items-center justify-center py-4'>
                <LoadingIcon className='text-secondary-500 h-5 w-5 animate-spin' />
            </div>
        );
    }

    return (
        <>
            <div className='max-h-[300px] space-y-3.5 overflow-y-auto'>
                {data?.data?.map((item: VideoStyle) => (
                    <VideoStyleItem key={item.id} item={item} />
                ))}
            </div>
            {hasError && (
                <p className='text-danger-600 mt-2 text-right text-sm font-medium'>
                    {formState.errors['video_style_id']?.message as string}
                </p>
            )}
        </>
    );
}

export default AddPageFormStep5;

